module.exports = __webpack_public_path__ + "static/OpenSans-Bold-f6ecab4e0db21c6eacdabce8e97339af.woff2";